import { useAsyncCallback, UseAsyncReturn } from 'react-async-hook';
import { FinanceResponse } from '@upstart/harmony/lib/legos/financingTypes';
import FinanceResponseService from '../../services/FinanceResponseService';
import { sendRicFormUpdateToCC } from '../../util/commandCenter';

type UseGetFinanceResponseForRIC = {
  asyncResponse: UseAsyncReturn<FinanceResponse>;
};

/**
 * Fetches Finance Response for use in the RIC Review page
 */
export const useGetFinanceResponseForRIC = ({
  responseId,
}: {
  responseId: string;
}): UseGetFinanceResponseForRIC => {
  const asyncResponse = useAsyncCallback<FinanceResponse>(async () => {
    const financeResponse = await FinanceResponseService.get(responseId, {
      withRICDefaults: true,
    });

    sendRicFormUpdateToCC({
      ricFormValues: financeResponse,
      isRicFormInvalid: false,
    });

    return financeResponse;
  });

  return {
    asyncResponse,
  };
};
